// create redux slice for livekit conference
import { createSlice, current } from "@reduxjs/toolkit";

import {
  updateUserSpaceConfig,
  updateRoomConfig,
} from "../../livekitConnection/userMap.ts";
import { AxiosLocal } from "../../utilities/axiosUtils.ts";

window.mobileCheck = function () {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const USER_TIERS = {
  TIER_0: "tier_0",
  TIER_1: "tier_1",
  TIER_2: "tier_2",
  TIER_3: "tier_3",
};

// layout types
export const LAYOUT_TYPES = {
  DYNAMIC_LAYOUT_VERTICAL: "dynamic_layout_vertical",
  DYNAMIC_LAYOUT_HORIZONTAL: "dynamic_layout_horizontal",
  DYNAMIC_GRID_LAYOUT: "dynamic_grid_layout",
  STAGE_LAYOUT: "stage_layout",
  SHARE_LAYOUT: "share_layout",
  MOBILE_LAYOUT: "mobile_layout",
};

export const conferenceSlice = createSlice({
  name: "conference",
  initialState: {
    conferenceName: "",
    conferenceId: "",
    remoteVideoStreams: {},
    remoteAudioStreams: {},
    participants: [],
    ShareUrl: "",
    layout: window.mobileCheck()
      ? LAYOUT_TYPES.MOBILE_LAYOUT
      : LAYOUT_TYPES.DYNAMIC_GRID_LAYOUT,
    currentActiveVideo: null,
    currentActiveUserId: "",
    isMobileStaged: false,
    hideHeader: true,
    replacedTrackId: [],
    HandRise: [],
    videoMuteIds: [],
    audioMuteIds: [],
    noVideo: [],
    hideUpArrow: false,
    participantsProperties: {},
    centrifugoClient: null,
    participantViewTypeChanged: "",
    participantPositions: {},
    directorMode: {
      mode: false,
      user_id: "",
    },
    directorLeft: false,
    devices: [],
    playing: [],
    centerStage: {
      layout_change: true,
      enabled: false,
      url: "",
      id: "",
    },
    playerTiming: {},
    prevLayout: LAYOUT_TYPES.DYNAMIC_GRID_LAYOUT,
    fullscreen: false,
    rotated: false,
  },
  reducers: {
    // setplayerTiming
    setplayerTiming: (state, action) => {
      let playerTiming = { ...state.playerTiming };
      playerTiming[action.payload.id] = action.payload.time;
      state.playerTiming = playerTiming;
    },

    // set devices
    setDevices: (state, action) => {
      let devices = [...state.devices];
      let newDevices = {
        name: action.payload.name,
        url: action.payload.url,
        user_id: action.payload.user_id,
        id: action.payload.id,
        device: action.payload.device,
        type: action.payload.type,
        file_name: action.payload.file_name,
      };
      devices.push(newDevices);
      state.devices = devices;
    },

    // replace devices
    replaceDevices: (state, action) => {
      state.devices = action.payload;
      console.log(action.payload, "action.payloadaction.payload");
    },
    setfullscreen: (state, action) => {
      state.fullscreen = action.payload;
    },

    //setrotated
    setrotated: (state, action) => {
      console.log(action.payload, "action.payload");
      state.rotated = action.payload;
    },

    //setplaying
    setplaying: (state, action) => {
      let playing = [...state.playing];
      let newPlaying = {
        id: action.payload.id,
        play: action.payload.play,
      };
      let index = playing.findIndex((item) => item.id == action.payload.id);
      if (index == -1) {
        playing.push(newPlaying);
      } else {
        playing[index] = newPlaying;
      }
      state.playing = playing;
    },
    // remove devices by id
    removeDevices: (state, action) => {
      let devices = [...state.devices];
      let newDevices = devices.filter(
        (device) => device.id != action.payload.id
      );
      state.devices = newDevices;
    },
    // set directorMode
    setdirectorMode: (state, action) => {
      let directorMode = { ...state.directorMode };
      directorMode.mode = action.payload.mode;
      if (!action.payload.mode) {
        directorMode.user_id = "";
      } else {
        directorMode.user_id = action.payload.user_id;
      }
      if (
        directorMode.mode &&
        directorMode.user_id == window.room?.myUserId()
      ) {
        updateRoomConfig({
          participantPositions: current(state).participantPositions,
          directorMode,
        });
      } else if (!directorMode.mode) {
        updateRoomConfig({ directorMode });
      }
      console.log(directorMode, "state.directorMode");
      state.directorMode = directorMode;
    },
    setparticipantPositions: (state, action) => {
      // set the participant positions from the action payload
      console.log(action.payload, "action.payload");
      // let participantPositions = Object.keys(action.participantPositions).filter

      state.participantPositions = action.payload;
    },
    switchParticipantPosition: (state, action) => {
      let participantPositions = { ...state.participantPositions };
      // set user_type
      if (participantPositions[action.payload.user_id_1]) {
        participantPositions[action.payload.user_id_1].user_type =
          action.payload.user_type;
        // isDevice

        participantPositions[action.payload.user_id_1].isDevice =
          action.payload.isDevice;
      } else {
        participantPositions[action.payload.user_id_1] = {
          user_type: action.payload.user_type,
          isDevice: action.payload.isDevice,
        };
      }

      let position = action.payload.position_1;
      let positions = [];
      // loop through participantPositions
      for (const [key, value] of Object.entries(participantPositions)) {
        //   find the participant with the same position as position
        let user_type =
          value.user_type != undefined
            ? value.user_type
            : window.room?.getParticipantById(key)?._properties?.user_type;
        if (action.payload.user_type == user_type) {
          if (key == action.payload.user_id_1) {
            value.position = position;
          } else if (value.position >= position) {
            value.position += 1;
          }
          value.user_type = action.payload.user_type;

          positions.push({ ...value, user_id: key });
        }
      }

      // sort the positions
      positions.sort((a, b) => a.position - b.position);
      // loop through the positions and assign the position to the participant
      for (let i = 0; i < positions.length; i++) {
        console.log(positions[i].position, "positions[i]");

        participantPositions[positions[i].user_id] = {
          position: i,
          user_type: positions[i].user_type,
        };
      }
      console.log(participantPositions, "positions");
      state.participantPositions = participantPositions;

      let newParticipantPositions = {};
      for (const [key, value] of Object.entries(
        current(state).participantPositions
      )) {
        if (key !== window.room?.myUserId()) {
          newParticipantPositions[key] = value;
        } else {
          newParticipantPositions["self"] = value;
        }
      }

      // updateUserSpaceConfig({ participantPositions: newParticipantPositions });
      if (
        state.directorMode.mode &&
        state.directorMode.user_id == window.room?.myUserId()
      ) {
        updateRoomConfig({ participantPositions });
      }
      //             AxiosLocal.post("user/space/config/",{
      //                 "subroom_slug":localStorage.getObject('currentSubSpaceSlug'),
      //     "user_id":localStorage.getObject('id'),
      //     "space_config":{

      //     }
      //             })
    },
    setParticipantPositions: (state, action) => {
      console.log("setParticipantPositions", action.payload);
      // set participant positions key user_id and value position
      let participantPositions = { ...state.participantPositions };
      if (action.payload.position === null) {
        delete participantPositions[action.payload.user_id];
      } else {
        let position = action.payload.position;
        let user_type = action.payload.user_type;

        while (Object.values(participantPositions).includes(position)) {
          position += 1;
        }
        participantPositions[action.payload.user_id] = { position, user_type };
      }
      state.participantPositions = participantPositions;
    },
    setParticipantViewTypeChanged: (state, action) => {
      state.participantViewTypeChanged = action.payload;
    },
    setCentrifugoClient: (state, action) => {
      state.centrifugoClient = action.payload;
    },
    setConferenceName: (state, action) => {
      state.conferenceName = action.payload;
    },
    setConferenceId: (state, action) => {
      state.conferenceId = action.payload;
    },
    setRemoteVideoStreams: (state, action) => {
      console.log(
        state,
        action,
        state.remoteVideoStreams,
        "setRemoteVideoStreams"
      );
      if (action.replace) {
        state.remoteVideoStreams = action.payload;
      } else {
        state.remoteVideoStreams = {
          ...action.payload,
          ...state.remoteVideoStreams,
        };
      }

      console.log(
        state,
        action,
        state.remoteVideoStreams,
        "setRemoteVideoStreams remoteVideoTracks1"
      );
    },
    // remove remote video stream and audio stream
    removeRemoteVideoStreams: (state, action) => {
      delete state.remoteVideoStreams[action.payload];
      delete state.remoteAudioStreams[action.payload];
    },
    setRemoteAudioStreams: (state, action) => {
      state.remoteAudioStreams = {
        ...action.payload,
        ...state.remoteAudioStreams,
      };
    },
    setParticipants: (state, action) => {
      state.participants = action.payload;
    },
    addParticipant: (state, action) => {
      state.participants.push(action.payload);
    },
    removeParticipant: (state, action) => {
      state.participants = state.participants.filter(
        (participant) => participant.id !== action.payload
      );
    },

    setShareUrl: (state, action) => {
      console.log("setShareUrl", action.payload);
      state.ShareUrl = action.payload;
      state.layout = LAYOUT_TYPES.SHARE_LAYOUT;
    },
    setLayout: (state, action) => {
      console.log(
        action.payload,
        state.layout,
        "same layout state.layoutstate.layout"
      );

      if (action.payload !== state.layout) {
        if (!action.payload) {
          if (window.mobileCheck()) {
            return;
          }
          state.layout = state.prevLayout;

          window.eventChanel.publish({
            event: "layoutChanged",
            layout: state.prevLayout,
            user_id: window.room.myUserId(),
          });
        } else {
          if (window.mobileCheck()) {
            return;
          }
          state.prevLayout = state.layout;
          state.layout = action.payload;
        }
      } else {
        console.log("same layout");
      }
    },
    setCenterStageDevice: (state, action) => {
      if (action.payload.layout_change) {
        state.layout = LAYOUT_TYPES.STAGE_LAYOUT;
      }
      state.centerStage = action.payload;
    },

    setCurrentActiveVideo: (state, action) => {
      state.currentActiveVideo = action.payload;
    },
    setcurrentActiveUserId: (state, action) => {
      state.currentActiveUserId = action.payload;
    },
    setisMobileStaged: (state, action) => {
      state.isMobileStaged = action.payload;
    },
    sethideHeader: (state, action) => {
      state.hideHeader = action.payload;
    },
    setreplacedTrackId: (state, action) => {
      //push action.payload to state.replacedTrackId
      state.replacedTrackId.push(action.payload);
    },

    checkCurrentActiveVideoRemoved: (state, action) => {
      //filter oldDevices with state.currentActiveUserId
      let oldDevicesWithCurrentActiveUserId = state.devices.filter(
        (device) => device.id == state.currentActiveUserId
      );

      if (state.currentActiveUserId) {
        if (
          state.currentActiveUserId === action.payload ||
          (oldDevicesWithCurrentActiveUserId.length === 0 &&
            state.centerStage.url)
        ) {
          state.currentActiveVideo = null;
          state.centerStage.enabled = false;

          if (state.layout === LAYOUT_TYPES.STAGE_LAYOUT) {
            if(window.mobileCheck()){
              state.layout = "mobile_layout";
            }else{
            state.layout = state.prevLayout;
            }
          }
        }
      }
    },

    switchCamera: (state, action) => {
      if (state.layout === LAYOUT_TYPES.STAGE_LAYOUT) {
        state.currentActiveUserId = action.payload.trackId;
        state.currentActiveVideo = action.payload.replacedTrack;
      }
    },

    checkDirectorLeft: (state, action) => {
      let devices = [...state.devices];

      let newDevices = devices.filter(
        (device) => device.user_id !== action.payload
      );
      let oldDevices = devices.filter(
        (device) => device.user_id == action.payload
      );
      console.log(oldDevices, "oldDevicesoldDevices");
      state.devices = newDevices;

      let director = state.directorMode.user_id;
      if (state.directorMode.mode && director === action.payload) {
        //turn off director mode
        state.directorMode.mode = false;
        state.directorMode.user_id = null;
      }
    },
    setCurrentActiveVideoAndLayout: (state, action) => {
      state.currentActiveVideo = action.payload.currentActiveVideo;
      state.layout = action.payload.layout;
    },

    setHandRise: (state, action) => {
      if (state.HandRise.includes(action.payload)) {
        let HandRisearr = state.HandRise.filter(
          (item) => item !== action.payload
        );
        state.HandRise = [...HandRisearr];
      } else {
        state.HandRise = [...state.HandRise, action.payload];
      }
    },

    setVideoMute: (state, action) => {
      if (action.payload.unmuted) {
        let videoMuteIdsList = state.videoMuteIds.filter(
          (item) => item !== action.payload.id
        );
        state.videoMuteIds = [...videoMuteIdsList];
      } else {
        console.log(action.payload.id, "videoMuteIdsList");

        state.videoMuteIds = [...state.videoMuteIds, action.payload.id];
      }
    },

    setAudioMute: (state, action) => {
      console.log(action, "audioMuteIdsList");
      if (action.payload.unmuted) {
        let audioMuteIdsList = state.audioMuteIds.filter(
          (item) => item !== action.payload.id
        );
        state.audioMuteIds = [...audioMuteIdsList];
      } else {
        state.audioMuteIds = [...state.audioMuteIds, action.payload.id];
      }
    },
    setNoVideo: (state, action) => {
      //push action.payload to state.noVideo

      //  state.noVideo = [...state.noVideo, action.payload];
      let noVideoList = [...state.noVideo];
      console.log(action.payload, noVideoList, "noVideo");
      noVideoList.push(action.payload);
      state.noVideo = noVideoList;
    },
    removeNoVideo: (state, action) => {
      let noVideoList = [...state.noVideo];
      let newNoVideoList = noVideoList.filter(
        (item) => item !== action.payload
      );
      state.noVideo = newNoVideoList;
    },
    sethideUpArrow: (state, action) => {
      state.hideUpArrow = action.payload;
    },
    setVideoSwitchRemote: (state, action) => {
      if (state.audioMuteIds.includes(action.payload)) {
        let audioMuteIdsList = state.audioMuteIds.filter(
          (item) => item !== action.payload
        );
        state.audioMuteIds = [...audioMuteIdsList];
      } else {
        state.audioMuteIds = [...state.audioMuteIds, action.payload];
      }
    },
    setParticipantsProperties: (state, action) => {
      switch (action.payload.action) {
        case "remove":
          let participantsProperties = state.participantsProperties;
          delete participantsProperties[action.payload.key];
          state.participantsProperties = participantsProperties;

        default:
          state.participantsProperties[action.payload.key] =
            action.payload.data;
      }
    },
  },
});

export const {
  setConferenceName,
  setConferenceId,
  setRemoteVideoStreams,
  removeRemoteVideoStreams,
  setRemoteAudioStreams,
  setParticipants,
  addParticipant,
  removeParticipant,
  setShareUrl,
  setLayout,
  setCenterStageDevice,
  setCurrentActiveVideo,
  setcurrentActiveUserId,
  setCurrentActiveVideoAndLayout,
  setHandRise,
  setVideoMute,
  setAudioMute,
  setNoVideo,
  removeNoVideo,
  setCentrifugoClient,
  setParticipantViewTypeChanged,
  setParticipantPositions,
  setparticipantPositions,
  switchParticipantPosition,
  setdirectorMode,
  setDevices,
  setplaying,
  replaceDevices,
  removeDevices,
  setplayerTiming,
  currentActiveUserId,
  setreplacedTrackId,
  checkCurrentActiveVideoRemoved,
  checkDirectorLeft,
  switchCamera,
  sethideUpArrow,
  setfullscreen,
  isMobileStaged,
  setisMobileStaged,
  hideHeader,
  sethideHeader,
  setrotated,
} = conferenceSlice.actions;
export default conferenceSlice.reducer;
